import React, { useEffect, useState } from "react";
import style from "./Images.module.css";
import edit3 from "../../../Assets/edit3.svg";
import add2 from "Assets/add1.svg";
import add1 from "Assets/plusblue.svg";
import download from "Assets/download.svg";
import delete1 from "../../../Assets/delete1.svg";

import more from "Assets/more.svg";
import { useSelector } from "react-redux";
import {
  AddEmbededVideo,
  StringFormater,
  CheckMediaType,
  checkIsIframeURL,
} from "helper/helper";
import { deleteWork, getUpdatedPortfolio } from "services/api";
import { Link, useNavigate } from "react-router-dom";
import Priview from "../PriviewCard/Priview";
import Swal from "sweetalert2";
import { dummyImages } from "constant/contants";
import { useWindow } from "hooks/useWindow";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  background,
} from "@chakra-ui/react";
import { ModelViewer } from "Components/ModalViewer/ModalViewer";
import swal from "sweetalert";

const ImageCards = ({ id, studentData, isRecruiter, userid }) => {
  const [currentTab, setCurrentTab] = useState("ALL");
  const [allTabs, setAllTabs] = useState([]); // ['ALL', 'NFT', '3D Environment', 'Interaction Design', 'Simulation', 'Digital twin', 'Unreal Experience']
  const user = JSON.parse(localStorage.getItem("user"));
  const [studentUploadedWork, setStudentUploadedWork] = useState([]);

  const [showMore, setShowMore] = useState({
    show: false,
    id: "",
  });
  const [modalOpen, setModalOpen] = useState({
    open: false,
    url: "",
    type: "",
  });
  const imageViewer = (url, type, uuid) => {
    if (userid || uuid) return;
    setModalOpen({
      open: true,
      url: url,
      type: type,
    });
  };
  const windowSize = useWindow();
  const [portfolio, setPortfolio] = useState([]);
  const [show, setShow] = useState({
    show: false,
    id: "",
  });

  // student upload work

  useEffect(() => {
    setStudentUploadedWork(studentData?.uploaded);
  }, [studentData]);

  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getUpdatedPortfolio(id);
        setPortfolio(data.data?.data);
      } catch (e) {
        console.log(e);
      }
    };
    if (id) {
      fetchData();
    }
  }, [studentData]);

  const handleGetdata = (uuid, url, type = "glb") => {
    const userId = JSON.parse(localStorage.getItem("user"));

    if (uuid && userId?.profile === "ajna_student" && !userid) {
      navigate(`/hiring/student/preview/${id}/${uuid}`);
    } else if (uuid && userid && userId?.profile === "ajna_student") {
      navigate(`/hiring/student/preview/${id}/${uuid}`);
    } else if (
      id &&
      (isRecruiter || userid || userId?.profile === "recruiter") &&
      uuid
    ) {
      navigate(`/hiring/student/preview/${id}/${uuid}`);
    } else {
      if (!userid && !uuid) {
        setModalOpen({
          open: true,
          url: url,
          type: type,
        });
      }
    }
  };
  const tabs = [
    {
      id: 1,
      tabTitle: "ALL",
    },
    {
      id: 2,
      tabTitle: "NFT",
    },
    {
      id: 3,
      tabTitle: "3D Environment",
    },
    {
      id: 5,
      tabTitle: "Interaction Design",
    },
    {
      id: 6,
      tabTitle: "Simulation",
    },
    {
      id: 7,
      tabTitle: "Digital twin",
    },
    {
      id: 7,
      tabTitle: "Unreal Experience",
    },
  ];

  const downloadHandler = (url) => {
    const link = document.createElement("a");
    if (link.download !== undefined) {
      link.href = url;
      const isImage =
        url.includes("jpg") || url.includes("png") || url.includes("jpeg");
      if (isImage) {
        link.download = url.substring(url.lastIndexOf("/") + 1, url.length);
        link.target = "_blank";
      }
      link.download = url.substring(url.lastIndexOf("/") + 1, url.length);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    if (studentUploadedWork?.length > 0 && isRecruiter) {
      const allTabs = studentUploadedWork?.reduce((acc, item) => {
        return acc.concat(item?.projectType?.toLowerCase());
      }, []);
      const uniqueTabs = [...new Set(allTabs)].map((item) => {
        return {
          id: item,
          tabTitle:
            tabs.find((tab) => tab.tabTitle?.toLowerCase()?.includes(item))
              ?.tabTitle || item,
        };
      });
      setAllTabs([
        {
          id: 1,
          tabTitle: "ALL",
        },
        ...uniqueTabs,
      ]);
    } else if (studentUploadedWork?.length > 0 && !isRecruiter) {
      setAllTabs(tabs);
    }
  }, [studentUploadedWork, isRecruiter]);

  const getImageByLevel = (level, data) => {
    if (data?.length === 0 && portfolio?.length === 0) return [];
    if (level === "ALL") {
      const filterData = data
        ?.map((item) => item)
        .concat(portfolio?.map((item) => item));
      return filterData;
    }

    const uploadedData = studentUploadedWork?.filter((item) =>
      item?.projectType?.toLowerCase()?.includes(level.toLowerCase())
    );
    const modifiedData = uploadedData?.map((item) => item);
    return modifiedData || [];
  };

  const deleteUploadWork = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await deleteWork(id);
          const filterData = studentUploadedWork?.filter(
            (item) => item._id !== id
          );
          setStudentUploadedWork(filterData);
          Swal.fire("Deleted!", "Your file has been deleted.", "success");
        } catch (e) {
          console.log(e);
        }
      }
    });
  };

  return (
    <>
      <Modal
        size="xl"
        isOpen={modalOpen.open}
        onClose={() =>
          setModalOpen({
            open: false,
            url: "",
            type: "",
          })
        }
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton zIndex={99} />
          <ModalBody>
            {modalOpen.type === "glb" ? (
              <ModelViewer url={modalOpen.url} />
            ) : (
              <img
                src={modalOpen.url}
                alt="portfolio"
                className={style.modalImage}
              />
            )}

            <div onClick={() => downloadHandler(modalOpen.url)}>
              <p className={style.Upload_work}>
                <span>
                  <img src={download} />
                </span>{" "}
                Download
              </p>
            </div>
            {/* <Lorem count={2} /> */}
          </ModalBody>
        </ModalContent>
      </Modal>
      <div className={style.cardContainer}>
        <div
          className={style.titileUploadwork}
          style={{
            justifyContent:
              studentData?.uploaded?.length === 0 && portfolio?.length === 0
                ? "flex-end"
                : "space-between",
          }}
        >
          {(studentData?.uploaded?.length > 0 || portfolio?.length > 0) && (
            <div className={style.cardsTitle}>
              {allTabs.map((tab, index) => {
                return (
                  <div
                    key={index}
                    id={tab.id}
                    className={style.tabTitle}
                    disabled={currentTab === `${tab.id}`}
                    onClick={() => setCurrentTab(tab.tabTitle)}
                    style={{
                      borderBottom:
                        currentTab === `${tab.tabTitle}`
                          ? "2px solid #6C56FB"
                          : "none",
                      padding: "8px 16px",
                      color:
                        currentTab === `${tab.tabTitle}`
                          ? "#6C56FB"
                          : "#000000",
                      fontWeight:
                        currentTab === `${tab.tabTitle}` ? "600" : "normal",
                      marginTop: "11px",
                    }}
                  >
                    {tab.tabTitle}
                  </div>
                );
              })}
            </div>
          )}
          {!isRecruiter && !userid && (
            <div className={style.uploadbtn}>
              <Link to="/hiring/student/StartBuildingProject">
                <button className={style.Uploadbutton}>
                  <img
                    src={windowSize > 500 ? add1 : add2}
                    alt="add"
                    style={{ color: "#FFFFFF" }}
                  />
                  Upload work
                </button>
              </Link>
            </div>
          )}
        </div>
        <div
          className={style.content}
          style={{
            marginBottom: "20px",
          }}
        >
          {allTabs?.map((tab, i) => {
            return (
              currentTab === tab.tabTitle && (
                <div
                  className={style.ImagesCard}
                  style={{
                    gridTemplateColumns:
                      getImageByLevel(tab?.tabTitle, studentUploadedWork)
                        ?.length > 0
                        ? "repeat(2, 1fr)"
                        : "repeat(1, 1fr)",
                  }}
                >
                  {getImageByLevel(tab.tabTitle, studentUploadedWork)?.length >
                  0 ? (
                    getImageByLevel(tab.tabTitle, studentUploadedWork)
                      ?.reverse()
                      ?.map(
                        ({ url, projectTitle, title, name, _id, fileURL }) =>
                          CheckMediaType(
                            Array.isArray(url) ? checkIsIframeURL(url) : url
                          ) !== null && (
                            <div className={style.overlay}>
                              <div
                                onMouseEnter={() => {
                                  _id &&
                                    !userid &&
                                    setShowMore({
                                      show: true,
                                      id: _id,
                                    });
                                }}
                                className={style.cardItem1}
                                onMouseLeave={() => {
                                  _id &&
                                    setShowMore({
                                      show: false,
                                      id: "",
                                    });
                                  setShow({
                                    show: false,
                                    id: "",
                                  });
                                }}
                              >
                                {CheckMediaType(
                                  Array.isArray(url)
                                    ? checkIsIframeURL(url)
                                    : url
                                ) === "video" && (
                                  <video
                                    className={style.videoContainer}
                                    src={
                                      Array.isArray(url)
                                        ? checkIsIframeURL(url)
                                        : url
                                    }
                                    // controls
                                    style={{
                                      borderRadius: "15px",
                                      objectFit: "cover",
                                    }}
                                  />
                                )}
                                {CheckMediaType(
                                  Array.isArray(url)
                                    ? checkIsIframeURL(url)
                                    : url
                                ) === "image" && (
                                  <img
                                    className={style.imageContainer}
                                    src={
                                      Array.isArray(url)
                                        ? checkIsIframeURL(url)
                                        : url
                                    }
                                    alt="images"
                                    style={{ borderRadius: "15px" }}
                                  />
                                )}
                                {CheckMediaType(
                                  Array.isArray(url)
                                    ? checkIsIframeURL(url)
                                    : url
                                ) === "other" && (
                                  <iframe
                                    src={AddEmbededVideo(
                                      Array.isArray(url)
                                        ? checkIsIframeURL(url)
                                        : url
                                    )}
                                    className={style.youtubeVideo}
                                    style={{ borderRadius: "15px" }}
                                  />
                                )}
                                {user?.profile === "ajna_student" && !userid ? (
                                  <h6
                                    onClick={() => {
                                      imageViewer(
                                        fileURL
                                          ? fileURL
                                          : Array.isArray(url)
                                          ? url[0]
                                          : url,
                                        fileURL ? "glb" : "img",
                                        _id
                                      );
                                      handleGetdata(
                                        _id,
                                        fileURL
                                          ? fileURL
                                          : Array.isArray(url)
                                          ? url[0]
                                          : url,
                                        fileURL ? "glb" : "img"
                                      );
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      height:
                                        windowSize < 500 ? "50px" : "350px",
                                      width: "100%",
                                      padding:
                                        windowSize < 500 ? "50px" : "150px",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {StringFormater(
                                      projectTitle || title || name
                                    )}
                                  </h6>
                                ) : (
                                  <h6
                                    onClick={() => {
                                      imageViewer(
                                        fileURL
                                          ? fileURL
                                          : Array.isArray(url)
                                          ? url[0]
                                          : url,
                                        fileURL ? "glb" : "img"
                                      );
                                      handleGetdata(
                                        _id,
                                        fileURL
                                          ? fileURL
                                          : Array.isArray(url)
                                          ? url[0]
                                          : url,
                                        fileURL ? "glb" : "img"
                                      );
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      height:
                                        windowSize < 500 ? "100px" : "350px",
                                      width: "100%",
                                      textTransform: "capitalize",
                                      padding:
                                        windowSize < 500 ? "80px" : "120px",
                                    }}
                                  >
                                    {StringFormater(
                                      projectTitle || title || name
                                    )}
                                  </h6>
                                )}

                                {user?.profile === "ajna_student" && (
                                  <div className={style.moreContainer}>
                                    <div className={style.more}>
                                      {_id && !userid && (
                                        <img
                                          src={more}
                                          className={style.moreImg}
                                          onClick={() =>
                                            setShow({
                                              show: !show.show,
                                              id:
                                                url +
                                                projectTitle +
                                                title +
                                                name,
                                            })
                                          }
                                        />
                                      )}
                                      {/* {!_id && <br />} */}
                                      {show.show &&
                                        url + projectTitle + title + name ===
                                          show.id && (
                                          <div
                                            className={style.dropDownContent}
                                          >
                                            {_id && (
                                              <div
                                                className={
                                                  style.dropDownBtnWithIcon
                                                }
                                              >
                                                <img
                                                  src={edit3}
                                                  alt="edit Icon"
                                                  className={style.moreImage}
                                                />
                                                <Link
                                                  to={`/hiring/student/editwork/${_id}`}
                                                >
                                                  Edit
                                                </Link>
                                              </div>
                                            )}

                                            <div
                                              className={
                                                style.dropDownBtnWithIcon
                                              }
                                            >
                                              <img
                                                className={style.moreImage}
                                                src={delete1}
                                                alt="delete Icon"
                                              />
                                              <a
                                                onClick={() =>
                                                  deleteUploadWork(_id)
                                                }
                                              >
                                                Delete
                                              </a>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )
                      )
                  ) : (
                    <div className={style.nodata}>
                      {isRecruiter ? (
                        ""
                      ) : (
                        <p
                          style={{
                            fontSize: windowSize < 500 ? "12px" : "16px",
                          }}
                        >
                          No data found{" "}
                          {tab.tabTitle === "ALL" ? "" : "for " + tab.tabTitle}.
                        </p>
                      )}
                    </div>
                  )}
                </div>
              )
            );
          })}

          {studentData?.uploaded?.length === 0 && portfolio?.length === 0 && (
            <div className={style.nodata}>
              {isRecruiter ? (
                "No data available for this student"
              ) : (
                <p>Your projects will be shown here</p>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ImageCards;
